import { CommunicationState } from '@kinetic-ui/data-layer';

export const LAYER_TYPE = 'connectedVehicles';

export enum StatusLayerIds {
  RSU_MODE_STATUS_LAYER_ID = 'RSU_MODE_STATUS',
  RSU_MAIN_STATUS_LAYER_ID = 'RSU_MAIN_STATUS',
}

export const errorCommunicationStates = [
  CommunicationState.Disabled,
  CommunicationState.Failed,
  CommunicationState.NoData,
];
